import { BuiltinSettings } from '@web/service';
import { environment as prodEnvironment } from './environment.prod';

export const environment: BuiltinSettings = {
  ...prodEnvironment,
  production: false,
};
